import './GirlPhoto.css';
import { useEffect, useState } from 'react'

function GirlPhoto({ handleClick, girlName, isAvailable, isSelected }) {
	let classname = 'girlPic';
	if(!isAvailable) {
		classname += ' unavailable'
	}
	if(isSelected) {
		classname += ' clicked'
	} else {
		classname += ' clear'
	}
	return(
		<div onClick={e => handleClick(e)} className={classname}>
			<img id={girlName} src={`./contestants/${girlName}.png`} alt={girlName}/>
		</div>
		)
}

export default GirlPhoto;